import { useState, useEffect } from 'react';
import { savV2Api } from '../../../Api/sav-v2/savV2Api';
import IUser from '../../../models/user';
import { useSavFilterStore } from '../../../Stores/SavFilterStore';

export default function ManagerFilterDropdown() {
  const [managers, setManagers] = useState<IUser[]>([]);
  const [loading, setLoading] = useState(false);
  const { selectedManagerFilter, setSelectedManagerFilter } = useSavFilterStore();

  useEffect(() => {
    loadManagers();
  }, []);

  const loadManagers = async () => {
    setLoading(true);
    try {
      const result = await savV2Api.getManagers({ page: 0, limit: 100 });
      setManagers(result.nodes);
    } catch (error) {
      console.error('Error loading managers:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-3 py-3 border-bottom">
      <label className="form-label" style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.7)', marginBottom: '0.5rem' }}>
        Filtrer par gestionnaire
      </label>
      <select
        value={selectedManagerFilter}
        onChange={(e) => setSelectedManagerFilter(e.target.value)}
        disabled={loading}
        style={{ fontSize: '0.875rem', display: 'block' }}
      >
        <option value="all">Tous les SAVs</option>
        <option value="my-savs">Mes SAVs</option>

        <option disabled>──────────</option>

        {loading ? (
          <option disabled>Chargement...</option>
        ) : managers.length === 0 ? (
          <option disabled>Aucun gestionnaire</option>
        ) : (
          managers.map((manager) => (
            <option key={manager.uuid} value={manager.uuid}>
              {manager.firstName} {manager.lastName}
            </option>
          ))
        )}
      </select>
    </div>
  );
}
